import React, { useEffect, useState } from 'react';
import { ImageOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { formatLocalizedDateTime } from '../utils/i18nFormatters';

export default function InspectionPhoto({ url, alt, capturedAt }) {
  const { t, i18n } = useTranslation();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [url]);

  if (failed) {
    const missingLabel = t('stewardCheckinRecords.detail.photoMissing');
    return (
      <div
        role="img"
        aria-label={missingLabel}
        data-testid="inspection-photo-missing"
        className="flex h-48 flex-col items-center justify-center rounded-lg border border-amber-300 bg-amber-50 p-4 text-center text-amber-950"
      >
        <ImageOff size={28} aria-hidden="true" />
        <strong className="mt-2 text-sm">{missingLabel}</strong>
        <span className="mt-1 text-xs text-amber-900">
          {t('stewardCheckinRecords.detail.photoMissingAt', {
            time: formatLocalizedDateTime(capturedAt, i18n.language),
          })}
        </span>
      </div>
    );
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className="overflow-hidden rounded-lg border border-slate-200 bg-slate-50"
    >
      <img
        src={url}
        alt={alt}
        loading="lazy"
        onError={() => setFailed(true)}
        className="h-48 w-full object-cover"
      />
    </a>
  );
}
